<div class="d-flex flex-row justify-content-start container-card-person">
    <ng-container *ngFor="let item of block">
        <div
            class="container-card-person__container-item effect-hover mx-3 text-left d-flex flex-column justify-content-between align-items-stretch no-print">
            <div class="container-card-person__container-item__image">
                <img loading="lazy" *ngIf="!item.foto" src="./assets/images/rectangle_gradient.png" alt="image | Lumsa">
                <img loading="lazy" *ngIf="item.foto" [src]="setImage(item.foto).url" [alt]="setImage(item.foto).tagAlt">
            </div>
            <div class="container-card-person__container-item__text">
                <p class="ls-label-large-semibold" [innerHTML]="item.field_nome + ' ' + item.field_cognome"></p>
                <p *ngIf="item.carica" class="ls-p-small" [innerHTML]="item.carica"></p>
                <p *ngIf="item.posizione" class="ls-p-small" [innerHTML]="item.posizione"></p>
            </div>
            <div class="container-card-person__container-item__text-hover d-flex flex-column justify-content-between">
                <p *ngIf="item.tassonomia_dipartimento" class="ls-label-small-bold text-uppercase text-neutral-60"
                    [innerHTML]="setStringDipartimento(item.tassonomia_dipartimento, item.bundle)"></p>
                <div>
                    <a [routerLink]="navigationService.splitUrlRouterLink(toPage(item.field_titolo)).path" [queryParams]="navigationService.splitUrlRouterLink(toPage(item.field_titolo)).queryParams">
                        <p class="ls-label-large-semibold" [innerHTML]="item.field_nome + ' ' + item.field_cognome"></p>
                    </a>
                    <p *ngIf="item.carica" class="ls-p-small" [innerHTML]="item.carica"></p>
                    <p *ngIf="item.field_posizione" class="ls-p-small" [innerHTML]="item.field_posizione"></p>
                </div>
                <!-- <p class="ls-p-small">nomecognome@lumsa.it</p> -->
            </div>
        </div>
        <app-sample-print 
            [title]="item.field_nome + ' ' + item.field_cognome" 
            [imageUrl]="setImage(item.foto).url" 
            [subtitle]="item.carica ? item.carica : item.posizione ? item.posizione : ''"
            [taxonomy]="setStringDipartimento(item.tassonomia_dipartimento, item.bundle)">
        </app-sample-print>
    </ng-container>
</div>
<!-- <div class="d-flex flex-row justify-content-start container-card-person">
    <ng-container *ngFor="let item of block">
        <div
            class="container-card-person__container-item effect-hover mx-3 text-left d-flex flex-column justify-content-between align-items-stretch">
            <div *ngIf="true" class="container-card-person__container-item__image">
                <img loading="lazy" *ngIf="!item.foto" src="./assets/images/rectangle_gradient.png" alt="image | Lumsa">
                <img loading="lazy" *ngIf="item.foto" [src]="setImage(item.foto).url" [alt]="setImage(item.foto).tagAlt">
            </div>
            <div class="container-card-person__container-item__text">
                <p class="ls-label-large-semibold" [innerHTML]="item.nome + ' ' + item.cognome"></p>
                <p *ngIf="item.carica" class="ls-p-small" [innerHTML]="item.carica"></p>
                <p *ngIf="item.posizione" class="ls-p-small" [innerHTML]="item.posizione"></p>
            </div>
            <div class="container-card-person__container-item__text-hover d-flex flex-column justify-content-between">
                <p *ngIf="item.tassonomia_dipartimento" class="ls-label-small-bold text-uppercase text-neutral-60"
                    [innerHTML]="setStringDipartimento(item.tassonomia_dipartimento, item.bundle)"></p>
                <div>
                    <p class="ls-label-large-semibold" [innerHTML]="item.nome + ' ' + item.cognome"></p>
                    <p *ngIf="item.carica" class="ls-p-small" [innerHTML]="item.carica"></p>
                    <p *ngIf="item.posizione" class="ls-p-small" [innerHTML]="item.posizione"></p>
                </div>
                <p class="ls-p-small">nomecognome@lumsa.it</p>
            </div>
        </div>
    </ng-container>
</div> -->